import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangeTitle } from '../exhibition.state.actions';

export const changeTitle = (ctx: StateContext<ExhibitionStateModel>, action: ChangeTitle) => {
    ctx.patchState({
        title: action.payload.title
    });
};
